import * as React from 'react';
import * as why from './why.module.scss';
import * as main from "../../../styles/main.module.scss";

export const Why = () => {
  return (
    <section className={why.why} id={"why"}>
      <div className={"container"}>
        <h2 className={main.mainTitle}>Зачем вам этот вебинар</h2>
        <ul className={why.why__list}>
          <li className={why.why__item}>чтобы вы всегда имели ясную память и запас сил</li>
          <li className={why.why__item}>чтобы легко побеждали в конкуренции с молодыми специалистами</li>
          <li className={why.why__item}>чтобы следующая работа была интересней и оплачивалась лучше</li>
          <li className={why.why__item}>чтобы вы вышли из застоя, не важно после однообразной работы или 15 лет присмотра за домом и детьми</li>
          <li className={why.why__item}>чтобы вы избавились от быстрой утомляемости</li>
          <li className={why.why__item}>чтобы имели больше свободного времени</li>
          <li className={why.why__item}>чтобы не были выжатым лимоном, а были бодрыми и полными сил
          </li>
          <li className={why.why__item}>чтобы избежали рисков сокращений и деменции</li>
          <li className={why.why__item}>чтобы рядом с вами было понимающее и поддерживающее  окружение</li>
        </ul>
      </div>
    </section>
  );
};
